import { QueryClient } from "@tanstack/react-query";

/**
 * Client for the react-query. Think about this as a "redux for server state".
 */
export const reactQueryClient = new QueryClient();
